import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { FilterLabels } from 'containers/filters'
import { Modal } from 'containers/misc'
import { LabelCreate } from 'containers/forms/labels'
import { Button } from 'components/misc'
import { meta } from 'helpers/decorators'
import { apiConfiguration, apiLabels } from 'helpers/decorators/api'
import { modal } from 'redux/modules/app'
import LabelsTable from '../../../components/sections/labels/LabelsTable/LabelsTable'
import { CONFIGURATION_KEYS } from '../../../constants/enums'
import { get } from 'lodash'

const enhance = compose(
  meta({
    title: 'Labels',
    intlKey: 'pageTitle.labels',
    noOverride: true
  }),
  apiLabels({
    list: true,
    filter: 'orgLabels'
  }),
  apiConfiguration({
        getValues: [
            CONFIGURATION_KEYS.enableLabels.id,
            CONFIGURATION_KEYS.enableOrganizationLabels.id,
            CONFIGURATION_KEYS.enableContactLabels.id,
            CONFIGURATION_KEYS.enableAwardLabels.id
        ]
    }),
  connect(({ auth }) => ({
      activeOrganization: auth.organization
  }), { modal })
)

class OfficeLabels extends Component {
  static propTypes = {
    labels: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    onDeleteLabel: PropTypes.func.isRequired,
    configuration: PropTypes.object.isRequired,
    hideAction: PropTypes.bool
  }

  states = {
      orgId: null
  }

  render() {
    const { activeOrganization, configuration, hideAction } = this.props

      const isPersonLabelsEnabled = get(configuration, `valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableLabels.id}].booleanValue`)

      const isContactLabelsEnabled = get(configuration, `valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableContactLabels.id}].booleanValue`)

      const isOrgLabelsEnabled = get(configuration, `valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableOrganizationLabels.id}].booleanValue`)

      const isAwardLabelsEnabled = get(configuration, `valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableAwardLabels.id}].booleanValue`)

      return (
      <div>
          {!hideAction && <div className="text--right base-margin--bottom">
          <Button
            intlKey="button.new_label"
            onClick={() => this.props.modal('modal-create-label')}
          >
            New Label
          </Button>
        </div>}
        <FilterLabels />
          <LabelsTable activeOrganization={activeOrganization} {...this.props} showOrgDetail={false} />
          <Modal id="modal-create-label" customActions fluid enableOverflow>
          <LabelCreate
              isPersonLabelsEnabled={isPersonLabelsEnabled}
              isContactLabelsEnabled={isContactLabelsEnabled}
              isOrgLabelsEnabled={isOrgLabelsEnabled}
              isAwardLabelsEnabled={isAwardLabelsEnabled}
              activeOrganization={activeOrganization}
              onClose={() => this.props.modal(null)}
          />
        </Modal>
      </div>
    )
  }
}

export default enhance(OfficeLabels)
